import client from './api-client';

/**
 * Endpoints del tablero "Pagos Inter Compañía" (lambda dashboard-intercia).
 *
 * A diferencia de los informes, estas lambdas responden el objeto de datos directo
 * (sin el envoltorio {code, object, message}), por lo que acá se retorna response.data.
 */
/**
 * RG-602 — Inicia la exportación a Excel de los casos de un indicador (asíncrona).
 * Responde `{ jobId, concepto, cantidad, cantidadWsi }`; con `cantidad: 0` y sin `jobId` no hay nada que
 * exportar. Un volumen excesivo responde 413 con el mensaje "acote el período".
 */
export const exportarCasosIntercia = async (query) => {
    const response = await client.postSinRedireccion('dashboard-intercia/exportar', { query });
    if (response.status === 200) return response.data;
    else throw new Error('No fue posible exportar los casos.');
}

/**
 * RG-602 — Estado del trabajo de exportación (se sondea). Responde `{ estado: 'EN_PROCESO' }`,
 * `{ estado: 'ERROR', mensaje }` o `{ estado: 'LISTO', url, filename, cantidad, cantidadWsi }`.
 */
export const estadoExportacionIntercia = async (query) => {
    const response = await client.postSinRedireccion('dashboard-intercia/exportar-estado', { query });
    if (response.status === 200) return response.data;
    else throw new Error('No fue posible consultar la exportación.');
}

export const getResumenDashboard = async (query) => {
    try {
        const response = await client.post('dashboard-intercia/resumen', { query });
        if (response.status === 200) return response.data;
        else throw new Error('No fue posible obtener el resumen del tablero.');
    } catch (error) {
        throw error;
    }
}
